<template>
  <section class="bylaws-section" id="bylaws">
    <div class="section-container">
      <div class="section-header">
        <h2 class="section-title">Official League Bylaws</h2>
        <p class="section-subtitle">Complete rules, regulations, and operational procedures for The Players League DFW</p>
      </div>
      
      <div class="bylaws-grid">
        
        <!-- Introduction Card -->
        <div class="bylaw-card introduction-card">
          <div class="card-header">
            <Icon name="mdi:hand-wave" />
            <h3>Welcome to The Family</h3>
          </div>
          <div class="card-content">
            <p>Welcome to The Players League DFW Pool League Family (TPL). This league was developed to give The Players a voice and give back to The Players. TPL is a fair and competitive league for players of all skill levels. Thank you for joining the Family!</p>
            <p>TPL strives for mutually beneficial relationships across the board. Meaning that Players, Venue Owners and Employees, and League employees must all benefit from the relationship. Therefore, Players should show respect for each other, employees and be good customers at all venues.</p>
          </div>
        </div>

        <!-- Membership & Fees -->
        <div class="bylaw-card">
          <div class="card-header">
            <Icon name="mdi:account-plus" />
            <h3>Membership & Fees</h3>
          </div>
          <div class="card-content">
            
            <div class="fee-section">
              <div class="fee-header">
                <Icon name="mdi:card-membership" />
                <h4>Annual Membership</h4>
              </div>
              <div class="fee-details">
                <div class="fee-item">
                  <span class="fee-amount">$20</span>
                  <span class="fee-description">to BCA (paid through League Operator)</span>
                </div>
                <div class="fee-item">
                  <span class="fee-amount">$10</span>
                  <span class="fee-description">processing fee (starting 2026)</span>
                </div>
              </div>
              <p class="fee-note">Must be paid on your first day of play. Players cannot play the 2nd week without paying annual membership fees.</p>
            </div>

            <div class="fee-section">
              <div class="fee-header">
                <Icon name="mdi:calendar-week" />
                <h4>Weekly Fees</h4>
              </div>
              <p>Weekly league fees vary depending on division. Please direct all fee questions to the LO or league representatives for clarification.</p>
              <p>Some venues may require additional fees for table use, while others provide tables at no extra charge.</p>
            </div>
            
          </div>
        </div>

        <!-- Ratings System -->
        <div class="bylaw-card">
          <div class="card-header">
            <Icon name="mdi:chart-line" />
            <h3>Player Rating System</h3>
          </div>
          <div class="card-content">
            
            <div class="rating-info">
              <Icon name="mdi:information" />
              <p>Players without established Fargo ratings are assigned starter ratings based on known ability and BU Rating Comparisons.</p>
            </div>

            <div class="rating-grid">
              <div class="rating-item">
                <span class="rating-value">250</span>
                <span class="rating-label">Minimum Starting Rating</span>
              </div>
              <div class="rating-item">
                <span class="rating-value">350</span>
                <span class="rating-label">Ladies (Unknown Players)</span>
              </div>
              <div class="rating-item">
                <span class="rating-value">450</span>
                <span class="rating-label">Men (Unknown Players)</span>
              </div>
            </div>

            <div class="monitoring-note">
              <Icon name="mdi:eye" />
              <p>Player performance is monitored until reaching 200 games played or robustness of 200. Starter ratings may be adjusted based on performance.</p>
            </div>
            
          </div>
        </div>

        <!-- Team Structure -->
        <div class="bylaw-card">
          <div class="card-header">
            <Icon name="mdi:account-group" />
            <h3>Team Structure</h3>
          </div>
          <div class="card-content">
            
            <div class="team-types">
              <div class="team-type">
                <div class="team-header">
                  <Icon name="mdi:account-multiple" />
                  <h4>4x4 Teams</h4>
                </div>
                <div class="team-details">
                  <p><strong>Up to 6 players</strong> - 4 must be available at match start to avoid forfeiture</p>
                  <p><strong>2050 Fargo cap</strong> - 4 highest players</p>
                </div>
              </div>
              
              <div class="team-type">
                <div class="team-header">
                  <Icon name="mdi:account-multiple-outline" />
                  <h4>3x3 Teams</h4>
                </div>
                <div class="team-details">
                  <p><strong>Up to 5 players</strong> - 3 must be available at match start to avoid forfeiture</p>
                </div>
              </div>
            </div>

            <div class="team-rules">
              <div class="rule-item">
                <Icon name="mdi:account-plus" />
                <div class="rule-content">
                  <h4>Adding Players</h4>
                  <p>No player can be added to a team until a league officer has agreed. Once a player has played, they are on the team and cannot be replaced.</p>
                </div>
              </div>
            </div>
            
          </div>
        </div>

        <!-- Match Procedures -->
        <div class="bylaw-card">
          <div class="card-header">
            <Icon name="mdi:clock" />
            <h3>Match Procedures</h3>
          </div>
          <div class="card-content">
            
            <div class="procedure-grid">
              <div class="procedure-item">
                <Icon name="mdi:calendar-sync" />
                <div class="procedure-content">
                  <h4>Make-up Matches</h4>
                  <p>Must be submitted on or before the date of the second to last match of the session.</p>
                </div>
              </div>
              
              <div class="procedure-item">
                <Icon name="mdi:clock-start" />
                <div class="procedure-content">
                  <h4>Starting Time</h4>
                  <p>Allow 15 minutes grace time for late players. Players can be played around until their turn comes again.</p>
                </div>
              </div>
              
              <div class="procedure-item">
                <Icon name="mdi:format-list-numbered" />
                <div class="procedure-content">
                  <h4>Team Lineups</h4>
                  <p>Team captains put lineups in the app and match them up together. One team keeps score in the scoring app.</p>
                </div>
              </div>
              
              <div class="procedure-item">
                <Icon name="mdi:account-switch" />
                <div class="procedure-content">
                  <h4>Substitute Players</h4>
                  <p>Subs can be added any time before a singles round starts. Must notify opposing captain. Cannot be refused unless player already played.</p>
                </div>
              </div>
              
              <div class="procedure-item">
                <Icon name="mdi:timer" />
                <div class="procedure-content">
                  <h4>Time Limits</h4>
                  <p>Players should report to the table within one minute of the previous match ending.</p>
                </div>
              </div>
              
              <div class="procedure-item">
                <Icon name="mdi:speedometer" />
                <div class="procedure-content">
                  <h4>Slow Play</h4>
                  <p>League Operator may put players on a 40-second clock at their discretion for slow play issues.</p>
                </div>
              </div>
            </div>
            
          </div>
        </div>

        <!-- Forfeits -->
        <div class="bylaw-card forfeit-card">
          <div class="card-header">
            <Icon name="mdi:flag" />
            <h3>Forfeit Procedures</h3>
          </div>
          <div class="card-content">
            
            <div class="forfeit-warning">
              <Icon name="mdi:alert" />
              <p><strong>Important:</strong> Teams forfeiting 2 consecutive weeks or 3 weeks total in a session will be automatically suspended from all league competition.</p>
            </div>

            <div class="forfeit-types">
              <div class="forfeit-type">
                <div class="forfeit-header">
                  <Icon name="mdi:account-group-outline" />
                  <h4>Full Team Forfeit</h4>
                </div>
                <div class="forfeit-rules">
                  <div class="forfeit-rule">
                    <span class="rule-icon">💰</span>
                    <span>Both teams must pay weekly fees</span>
                  </div>
                  <div class="forfeit-rule">
                    <span class="rule-icon">📊</span>
                    <span>Forfeiting team receives 0 points</span>
                  </div>
                  <div class="forfeit-rule">
                    <span class="rule-icon">🏆</span>
                    <span>Other team receives their weekly average in points</span>
                  </div>
                  <div class="forfeit-rule">
                    <span class="rule-icon">📈</span>
                    <span>Fargo ratings not affected by forfeits</span>
                  </div>
                </div>
              </div>
              
              <div class="forfeit-type">
                <div class="forfeit-header">
                  <Icon name="mdi:account-outline" />
                  <h4>Individual Player Forfeit (1 Player Max)</h4>
                </div>
                <div class="forfeit-rules">
                  <div class="forfeit-rule">
                    <span class="rule-icon">💰</span>
                    <span>Weekly fees must be paid for forfeiting players</span>
                  </div>
                  <div class="forfeit-rule">
                    <span class="rule-icon">📊</span>
                    <span>Forfeiting player receives 0 points, opponent gets 10 points</span>
                  </div>
                  <div class="forfeit-rule">
                    <span class="rule-icon">📈</span>
                    <span>Fargo rating calculated using average of all players</span>
                  </div>
                </div>
              </div>
            </div>
            
          </div>
        </div>

        <!-- Timeouts -->
        <div class="bylaw-card timeout-card">
          <div class="card-header">
            <Icon name="mdi:timer" />
            <h3>Timeout Rules</h3>
            <div class="timeout-badge">3 Per Match</div>
          </div>
          <div class="card-content">
            
            <div class="timeout-overview">
              <p>Teams are allowed <strong>3 timeouts per match</strong> that can be used at any time during the game (Exception to BCAPL rules).</p>
            </div>
            
            <div class="timeout-rules">
              <div class="timeout-rule">
                <Icon name="mdi:hand-back-right" />
                <div class="rule-text">
                  <h4>Initiating Timeouts</h4>
                  <p>Player or team member calls timeout. If team member suggests it, player may refuse but timeout is still considered used.</p>
                </div>
              </div>
              
              <div class="timeout-rule">
                <Icon name="mdi:coin" />
                <div class="rule-text">
                  <h4>Timeout Token</h4>
                  <p>Person giving timeout hands opposing team a coin or glass bead to indicate timeout was used.</p>
                </div>
              </div>
              
              <div class="timeout-rule">
                <Icon name="mdi:clock-outline" />
                <div class="rule-text">
                  <h4>Time Limit</h4>
                  <p>Timeouts limited to <strong>1 minute</strong> maximum duration.</p>
                </div>
              </div>
            </div>
            
          </div>
        </div>

        <!-- Conduct & Penalties -->
        <div class="bylaw-card conduct-card">
          <div class="card-header">
            <Icon name="mdi:shield-account" />
            <h3>Conduct & Penalties</h3>
          </div>
          <div class="card-content">
            
            <div class="conduct-overview">
              <Icon name="mdi:information" />
              <p>Unsportsmanlike conduct guidelines follow Official BCA Pool League Rules, including actions that are embarrassing, disruptive, or detrimental to players, spectators, officials, or the sport.</p>
            </div>

            <div class="penalty-levels">
              <div class="penalty-level">
                <Icon name="mdi:alert" />
                <div class="penalty-content">
                  <h4>Warning</h4>
                  <p>First level response to minor infractions</p>
                </div>
              </div>
              
              <div class="penalty-level">
                <Icon name="mdi:cancel" />
                <div class="penalty-content">
                  <h4>Suspension</h4>
                  <p>Temporary removal from league play</p>
                </div>
              </div>
              
              <div class="penalty-level">
                <Icon name="mdi:close-circle" />
                <div class="penalty-content">
                  <h4>Expulsion</h4>
                  <p>Permanent removal with prize money forfeiture</p>
                </div>
              </div>
            </div>
            
          </div>
        </div>

        <!-- Additional Rules -->
        <div class="bylaw-card additional-card">
          <div class="card-header">
            <Icon name="mdi:clipboard-list" />
            <h3>Additional Rules</h3>
          </div>
          <div class="card-content">
            
            <div class="additional-rules">
              <div class="additional-rule">
                <Icon name="mdi:coffee" />
                <div class="rule-content">
                  <h4>Bathroom / Smoke Breaks</h4>
                  <p>Can only be taken between games, not during active play.</p>
                </div>
              </div>
              
              <div class="additional-rule">
                <Icon name="mdi:account-remove" />
                <div class="rule-content">
                  <h4>Drop Out Teams</h4>
                  <p>Teams dropping out forfeit all prize money and are responsible for full session fees. Players cannot rejoin until all fees are paid.</p>
                </div>
              </div>
            </div>
            
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
// No script needed for this static component yet
</script>

<style scoped>
.bylaws-section {
  padding: 80px 0;
  background: 
    linear-gradient(180deg, rgba(15, 23, 42, 0.9) 0%, rgba(30, 58, 138, 0.9) 100%),
    url('/images/billiards-4-1920w.webp');
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  position: relative;
  overflow: hidden;
}

.bylaws-section::before {
  content: '';
  position: absolute;
  inset: 0;
  background: 
    radial-gradient(circle at 20% 30%, rgba(255, 184, 28, 0.08) 0%, transparent 50%),
    radial-gradient(circle at 80% 70%, rgba(59, 130, 246, 0.08) 0%, transparent 50%);
  z-index: 1;
}

.section-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
  position: relative;
  z-index: 2;
}

.section-header {
  text-align: center;
  margin-bottom: 64px;
}

.section-title {
  color: var(--gold);
  font-size: 3rem;
  font-family: var(--font-heading);
  font-weight: 700;
  margin-bottom: 16px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  position: relative;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: -12px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 3px;
  background: linear-gradient(90deg, transparent, var(--gold), transparent);
  border-radius: 2px;
}

.section-subtitle {
  color: var(--cream);
  font-size: 1.2rem;
  opacity: 0.9;
  margin-top: 24px;
  line-height: 1.6;
}

/* Bylaws Grid */
.bylaws-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 32px;
}

.introduction-card {
  grid-column: 1 / -1;
}

/* Bylaw Cards */
.bylaw-card {
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(15px);
  border-radius: 20px;
  border: 1px solid rgba(255, 184, 28, 0.2);
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
}

.bylaw-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, var(--gold), transparent);
  opacity: 0;
  transition: opacity 0.4s ease;
}

.bylaw-card:hover {
  transform: translateY(-8px);
  border-color: rgba(255, 184, 28, 0.4);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
}

.bylaw-card:hover::before {
  opacity: 1;
}

/* Card Headers */
.card-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 24px 32px 16px;
  border-bottom: 1px solid rgba(255, 184, 28, 0.1);
  position: relative;
}

.card-header svg {
  font-size: 2rem;
  color: var(--gold);
  flex-shrink: 0;
}

.card-header h3 {
  color: var(--gold);
  font-size: 1.6rem;
  font-family: var(--font-heading);
  font-weight: 600;
  margin: 0;
  flex: 1;
}

/* Badges */
.timeout-badge {
  background: linear-gradient(135deg, var(--gold) 0%, var(--light-gold) 100%);
  color: var(--navy-blue);
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 8px rgba(255, 184, 28, 0.3);
}

/* Card Content */
.card-content {
  padding: 24px 32px 32px;
}

.card-content p {
  color: var(--cream);
  line-height: 1.7;
  margin-bottom: 20px;
  font-size: 1rem;
}

.card-content p:last-child {
  margin-bottom: 0;
}

/* Fee Sections */
.fee-section {
  margin-bottom: 32px;
}

.fee-section:last-child {
  margin-bottom: 0;
}

.fee-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(255, 184, 28, 0.1);
}

.fee-header svg {
  font-size: 1.4rem;
  color: var(--gold);
}

.fee-header h4 {
  color: var(--gold);
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0;
}

.fee-details {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 16px;
}

.fee-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 16px;
  background: rgba(255, 184, 28, 0.05);
  border-radius: 8px;
  border: 1px solid rgba(255, 184, 28, 0.1);
}

.fee-amount {
  background: linear-gradient(135deg, var(--gold) 0%, var(--light-gold) 100%);
  color: var(--navy-blue);
  padding: 6px 12px;
  border-radius: 20px;
  font-weight: 700;
  font-size: 0.9rem;
  white-space: nowrap;
}

.fee-description {
  color: var(--cream);
  font-size: 0.95rem;
  line-height: 1.5;
}

.fee-note {
  color: var(--cream);
  font-size: 0.95rem;
  opacity: 0.9;
  font-style: italic;
  background: rgba(59, 130, 246, 0.1);
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid rgba(59, 130, 246, 0.2);
}

/* Rating System */
.rating-info {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px 20px;
  background: rgba(59, 130, 246, 0.1);
  border: 1px solid rgba(59, 130, 246, 0.2);
  border-radius: 10px;
  margin-bottom: 24px;
}

.rating-info svg {
  font-size: 1.3rem;
  color: var(--sky-blue);
  flex-shrink: 0;
  margin-top: 2px;
}

.rating-info p {
  margin: 0;
  font-size: 0.95rem;
}

.rating-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}

.rating-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  background: rgba(255, 184, 28, 0.05);
  border: 1px solid rgba(255, 184, 28, 0.1);
  border-radius: 12px;
  text-align: center;
  transition: all 0.3s ease;
}

.rating-item:hover {
  background: rgba(255, 184, 28, 0.08);
  border-color: rgba(255, 184, 28, 0.2);
  transform: translateY(-2px);
}

.rating-value {
  background: linear-gradient(135deg, var(--gold) 0%, var(--light-gold) 100%);
  color: var(--navy-blue);
  padding: 12px 16px;
  border-radius: 50%;
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 12px;
  box-shadow: 0 4px 12px rgba(255, 184, 28, 0.3);
}

.rating-label {
  color: var(--cream);
  font-size: 0.9rem;
  font-weight: 500;
}

.monitoring-note {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px 20px;
  background: rgba(255, 184, 28, 0.08);
  border: 1px solid rgba(255, 184, 28, 0.2);
  border-radius: 10px;
}

.monitoring-note svg {
  font-size: 1.3rem;
  color: var(--gold);
  flex-shrink: 0;
  margin-top: 2px;
}

.monitoring-note p {
  margin: 0;
  font-size: 0.95rem;
}

/* Team Structure */
.team-types {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 32px;
}

.team-type {
  background: rgba(255, 184, 28, 0.05);
  border: 1px solid rgba(255, 184, 28, 0.1);
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.team-type:hover {
  background: rgba(255, 184, 28, 0.08);
  border-color: rgba(255, 184, 28, 0.2);
  transform: translateY(-2px);
}

.team-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  background: rgba(255, 184, 28, 0.1);
  border-bottom: 1px solid rgba(255, 184, 28, 0.1);
}

.team-header svg {
  font-size: 1.5rem;
  color: var(--gold);
}

.team-header h4 {
  color: var(--gold);
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0;
}

.team-details {
  padding: 20px;
}

.team-details p {
  margin: 0;
  color: var(--cream);
  font-size: 0.95rem;
  line-height: 1.6;
}

.team-rules {
  border-top: 1px solid rgba(255, 184, 28, 0.1);
  padding-top: 24px;
}

.rule-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 20px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  border: 1px solid rgba(255, 184, 28, 0.1);
  transition: all 0.3s ease;
}

.rule-item:hover {
  background: rgba(255, 184, 28, 0.05);
  border-color: rgba(255, 184, 28, 0.2);
}

.rule-item svg {
  font-size: 1.8rem;
  color: var(--gold);
  flex-shrink: 0;
  margin-top: 2px;
}

.rule-content h4 {
  color: var(--gold);
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 8px;
}

.rule-content p {
  color: var(--cream);
  font-size: 0.95rem;
  line-height: 1.6;
  margin: 0;
  opacity: 0.9;
}

/* Procedures Grid */
.procedure-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
}

.procedure-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 20px;
  background: rgba(255, 184, 28, 0.05);
  border-radius: 12px;
  border: 1px solid rgba(255, 184, 28, 0.1);
  transition: all 0.3s ease;
}

.procedure-item:hover {
  background: rgba(255, 184, 28, 0.08);
  border-color: rgba(255, 184, 28, 0.2);
  transform: translateY(-2px);
}

.procedure-item svg {
  font-size: 1.8rem;
  color: var(--gold);
  flex-shrink: 0;
  margin-top: 2px;
}

.procedure-content h4 {
  color: var(--gold);
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 8px;
}

.procedure-content p {
  color: var(--cream);
  font-size: 0.95rem;
  line-height: 1.6;
  margin: 0;
  opacity: 0.9;
}

/* Forfeit Styles */
.forfeit-warning {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px 20px;
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.3);
  border-radius: 10px;
  margin-bottom: 24px;
}

.forfeit-warning svg {
  font-size: 1.3rem;
  color: #fca5a5;
  flex-shrink: 0;
  margin-top: 2px;
}

.forfeit-warning p {
  margin: 0;
  color: #fca5a5;
  font-weight: 600;
}

.forfeit-types {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
}

.forfeit-type {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  border: 1px solid rgba(255, 184, 28, 0.1);
  overflow: hidden;
}

.forfeit-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  background: rgba(255, 184, 28, 0.1);
  border-bottom: 1px solid rgba(255, 184, 28, 0.1);
}

.forfeit-header svg {
  font-size: 1.5rem;
  color: var(--gold);
}

.forfeit-header h4 {
  color: var(--gold);
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0;
}

.forfeit-rules {
  padding: 20px;
}

.forfeit-rule {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  padding: 10px;
  background: rgba(255, 184, 28, 0.05);
  border-radius: 8px;
}

.forfeit-rule:last-child {
  margin-bottom: 0;
}

.rule-icon {
  font-size: 1.2rem;
  width: 24px;
  text-align: center;
}

.forfeit-rule span:last-child {
  color: var(--cream);
  font-size: 0.95rem;
  line-height: 1.5;
}

/* Timeout Styles */
.timeout-overview {
  margin-bottom: 24px;
  padding: 20px;
  background: rgba(255, 184, 28, 0.08);
  border-radius: 12px;
  border: 1px solid rgba(255, 184, 28, 0.2);
}

.timeout-overview p {
  margin: 0;
  font-size: 1.1rem;
  text-align: center;
}

.timeout-rules {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.timeout-rule {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 20px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  border: 1px solid rgba(255, 184, 28, 0.1);
  transition: all 0.3s ease;
}

.timeout-rule:hover {
  background: rgba(255, 184, 28, 0.05);
  border-color: rgba(255, 184, 28, 0.2);
}

.timeout-rule svg {
  font-size: 1.8rem;
  color: var(--gold);
  flex-shrink: 0;
  margin-top: 2px;
}

.rule-text h4 {
  color: var(--gold);
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 8px;
}

.rule-text p {
  color: var(--cream);
  font-size: 0.95rem;
  line-height: 1.6;
  margin: 0;
  opacity: 0.9;
}

/* Conduct Styles */
.conduct-overview {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px 20px;
  background: rgba(59, 130, 246, 0.08);
  border: 1px solid rgba(59, 130, 246, 0.2);
  border-radius: 10px;
  margin-bottom: 24px;
}

.conduct-overview svg {
  font-size: 1.3rem;
  color: var(--sky-blue);
  flex-shrink: 0;
  margin-top: 2px;
}

.conduct-overview p {
  margin: 0;
  font-size: 0.95rem;
}

.penalty-levels {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}

.penalty-level {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  background: rgba(255, 184, 28, 0.05);
  border: 1px solid rgba(255, 184, 28, 0.1);
  border-radius: 12px;
  text-align: center;
  transition: all 0.3s ease;
}

.penalty-level:hover {
  background: rgba(255, 184, 28, 0.08);
  border-color: rgba(255, 184, 28, 0.2);
  transform: translateY(-2px);
}

.penalty-level svg {
  font-size: 2rem;
  color: var(--gold);
  margin-bottom: 12px;
}

.penalty-content h4 {
  color: var(--gold);
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 8px;
}

.penalty-content p {
  color: var(--cream);
  font-size: 0.9rem;
  line-height: 1.5;
  margin: 0;
  opacity: 0.9;
}

/* Additional Rules */
.additional-rules {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.additional-rule {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 20px;
  background: rgba(255, 184, 28, 0.05);
  border-radius: 12px;
  border: 1px solid rgba(255, 184, 28, 0.1);
  transition: all 0.3s ease;
}

.additional-rule:hover {
  background: rgba(255, 184, 28, 0.08);
  border-color: rgba(255, 184, 28, 0.2);
  transform: translateY(-2px);
}

.additional-rule svg {
  font-size: 1.8rem;
  color: var(--gold);
  flex-shrink: 0;
  margin-top: 2px;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .bylaws-grid {
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: 28px;
  }
}

@media (max-width: 768px) {
  .bylaws-section {
    padding: 60px 0;
  }
  
  .section-container {
    padding: 0 16px;
  }
  
  .section-header {
    margin-bottom: 48px;
  }
  
  .section-title {
    font-size: 2.2rem;
  }
  
  .bylaws-grid {
    grid-template-columns: 1fr;
    gap: 24px;
  }
  
  .procedure-grid,
  .team-types,
  .forfeit-types,
  .penalty-levels,
  .rating-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  
  .card-header,
  .card-content {
    padding-left: 20px;
    padding-right: 20px;
  }
  
  .fee-details {
    gap: 8px;
  }
  
  .fee-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}

@media (max-width: 480px) {
  .section-title {
    font-size: 1.8rem;
  }
  
  .section-subtitle {
    font-size: 1.1rem;
  }
  
  .card-header {
    flex-direction: column;
    text-align: center;
    gap: 12px;
  }
  
  .timeout-badge {
    order: -1;
  }
  
  .procedure-item,
  .rule-item,
  .timeout-rule,
  .additional-rule {
    padding: 16px;
  }
  
  .forfeit-rule {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}
</style>
